﻿(function () {
    "use strict";

    angular.module("app").controller("TemplatesController", TemplatesController);

    TemplatesController.$inject = [];

    function TemplatesController() {
        var vm = this;
        vm.showDeletedView = false
        vm.$onInit = onInit;

        function onInit() {
            vm.showDeletedView = (location.hash.indexOf('/deleted') > -1);
        }
    }
})();